/**
 * @description Application region enumeration.
 */
export enum Region {
  US = 'US',
  ES = 'ES',
  UK = 'UK',
  AU = 'AU',
  CA = 'CA',
  FR = 'FR',
  DE = 'DE',
  IT = 'IT',
  LU = 'LU',
  LT = 'LT',
  BE = 'BE',
  NL = 'NL',
  AT = 'AT',
  IE = 'IE',
  DK = 'DK',
  FI = 'FI',
  SE = 'SE',
  NO = 'NO',
  CH = 'CH',
  CL = 'CL',
  NZ = 'NZ',
  MY = 'MY',
  PT = 'PT',
  GR = 'GR',
  PL = 'PL',
  CZ = 'CZ',
  SG = 'SG',
  SN = 'SN',
  RO = 'RO',
  PR = 'PR',
}


// WEBPACK FOOTER //
// ./src/environment/region.ts